import React from "react";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import { DA_IconNames } from "@danishagro/shared/src/components/atoms/Icon/Icon.component";
import { DA_InlineLink } from "@danishagro/shared/src/components/atoms/InlineLink/InlineLink.component";
import { useTranslations } from "@danishagro/shared/src/contexts/translations/translations.context";
import { DepartmentProps } from "./Department.interface";
// eslint-disable-next-line css-modules/no-unused-class
import S from "./Department.module.scss";

export const Department = (props: DepartmentProps) => {
    const { getDictionaryString } = useTranslations();

    const googleMapsUrl = `http://www.google.com/maps/dir/${props.props?.googleMap?.address?.coordinates?.lat},${props.props?.googleMap?.address?.coordinates?.lng}`;

    return (
        <div
            className={cn(S.wrapper, props.className)}
            onClick={props.onDepartmentChange}
            onKeyDown={props.onDepartmentChange}
            role="presentation"
        >
            <div className={S.content}>
                {/** Address */}
                <div className={S.addressWrapper}>
                    {/** City */}
                    {props.props?.departmentName ? (
                        <strong className={S.city}>{props.props?.departmentName}</strong>
                    ) : null}

                    {/** Address */}
                    {props.props?.address ? <span>{props.props?.address}</span> : null}

                    {/** Zip & City */}
                    {props.props?.zipCode || props.props?.city ? (
                        <span>
                            {props.props?.zipCode} {props.props?.city}
                        </span>
                    ) : null}

                    {/**Phone */}
                    {props.props?.departmentPhone ? (
                        <span className={S.phone}>
                            <DA_InlineLink
                                title={props.props?.departmentPhone}
                                href={`tel:${props.props?.departmentPhone}`}
                                icon={DA_IconNames.PhoneOutline}
                                target="_self"
                                className={S.phoneIcon}
                            />
                        </span>
                    ) : null}

                    {props?.props?.link ? (
                        <DA_InlineLink
                            title={props?.props.link?.name}
                            href={props?.props.link?.url}
                            target={props?.props.link?.target}
                        />
                    ) : null}
                </div>
                {/** Directions */}
                {props.props?.googleMap ? (
                    <div className={S.directionsWrapper}>
                        <DA_InlineLink
                            title={getDictionaryString("Map.ShowRoute")}
                            icon={DA_IconNames.Pin}
                            href={googleMapsUrl}
                        />
                    </div>
                ) : null}
            </div>

            {/** Open & Signup */}
            {props.props?.isHarvest ? (
                <div className={S.signupWrapper}>
                    <span className={S.signupLabel}>
                        {getDictionaryString("Department.OpenForCrops")}
                    </span>
                </div>
            ) : null}
        </div>
    );
};
